// SkipLink — first-focusable skip-to-main-content link.
//
// Plan ref: 06-02-PLAN §Task 1 step 5
//          + 06-RESEARCH-motion-responsive-a11y.md §5 (a11y), §10 (focus mgmt)
//          + WCAG 2.2 AA — 2.4.1 Bypass Blocks
//
// Visually hidden by default (Tailwind sr-only), revealed on :focus
// (focus:not-sr-only) at top-left so keyboard users can skip past the
// MainNav and any other prefix UI on Tab. Targets <main id="main">,
// which LaneShell wraps every lane in.

export function SkipLink(): JSX.Element {
  return (
    <a
      href="#main"
      // Explicit tabIndex is load-bearing for Safari/WebKit (2026-09-01):
      // it omits links from sequential Tab order unless macOS "Full Keyboard
      // Access" is on, so the first Tab sailed straight past this link and
      // WCAG 2.4.1 Bypass Blocks was unmet for every default-config Safari
      // user. tabindex="0" opts the element into the tab sequence on every
      // engine without changing its semantics.
      tabIndex={0}
      data-skip-link=""
      className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-surface-2 focus:px-3 focus:py-2 focus:text-fg-default focus:shadow-focus-ring"
    >
      Skip to main content
    </a>
  );
}
